import { Link } from "@shopify/hydrogen";
import { useState, useRef } from "react";
import { NavPlusIcon, NavMinusIcon } from "../../elements/Icon";
const NavigationItems = (props) => {
  const [showSubMenu, setShowSubMenu] = useState("");
  const [clickedIndex, setClickedIndex] = useState("");

  const handleClick = (index) => {
    if (index === clickedIndex) setShowSubMenu(!showSubMenu);
    if (index !== clickedIndex) setShowSubMenu(true);
    setClickedIndex(index);
  };

  const { collections } = props;
  return (
    <div className="flex flex-col w-full gap-6 pt-6 pl-4 bg-opacity-95">
      {collections.map((collectionItem, index) => {
        return (
          <div
            key={index}
            className="flex flex-col items-start justify-start w-full"
          >
            <div
              onClick={() => handleClick(index)}
              className="w-full flex justify-between items-center font-gotham-bold text-[#2A3238]"
            >
              {collectionItem.title === "All BIKES" ||
              collectionItem.title === "ALL GEAR" ? (
                <Link
                  onClick={(e) => props.toggleMobileNav(e)}
                  to={collectionItem.handle}
                >
                  {collectionItem.title}{" "}
                </Link>
              ) : (
                <span>{collectionItem.title}</span>
              )}
              <div>
                {collectionItem.title !== "All BIKES" && collectionItem.title !== "ALL GEAR" ? (
                  showSubMenu === true && clickedIndex === index ? (
                    <NavMinusIcon />
                  ) : (
                    <NavPlusIcon />
                  )
                ):null}
              </div>
            </div>
            {showSubMenu === true && clickedIndex === index && (
              <div className="flex flex-col items-start justify-start w-full gap-6 pt-6 pl-4">
                {collectionItem.sub_collections.map((subCollectionItem, i) => {
                  return ( subCollectionItem.label.length > 0 &&
                    <div className="w-full" key={i}>
                      <div
                        key={index}
                        onClick={(e) => props.toggleMobileNav(e)}
                      >
                        {subCollectionItem.sub_title ? (
                          <Link
                            to={" " + subCollectionItem.handle}
                            className="text-[#2A3238] font-gotham-light flex flex-col w-full"
                          >
                            {subCollectionItem.sub_title}
                          </Link>
                        ) : (
                          <Link
                            to={" " + subCollectionItem.handle}
                            className="text-[#2A3238] font-light"
                          >
                            {subCollectionItem.view_title}
                          </Link>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default NavigationItems;
